<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('dashboard')"></cm-navbar>
                <!-- END header -->
                <f7-block :set="num = 0">
                    <f7-row v-for="(i, index) in rows" :key="index">
                        <f7-col v-if="routes[num]">
                            <span @click="changeRoute($event)" :route="routes[num].name">
                                <f7-card>
                                    <f7-card-content class="text-align-center">
                                        <f7-icon :f7="routes[num].icon"></f7-icon>
                                        <p class="title">{{ $ml.get(routes[num].title) }}</p>
                                        <p :set="num = num + 1" style="display: none;"></p>
                                    </f7-card-content>
                                </f7-card>
                            </span>
                        </f7-col>

                        <f7-col v-if="routes[num]">
                            <span @click="changeRoute($event)" :route="routes[num].name">
                                <f7-card>
                                    <f7-card-content class="text-align-center">
                                        <f7-icon :f7="routes[num].icon"></f7-icon>
                                        <p class="title">{{ $ml.get(routes[num].title) }}</p>
                                        <p :set="num = num + 1" style="display: none;"></p>
                                    </f7-card-content>
                                </f7-card>
                            </span>
                        </f7-col>
                    </f7-row>
                </f7-block>

                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>
<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import routers  from '../router'

    export default {
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                rows: 0,
                routes: [],
            }
        },
        methods: {
            changeRoute(e) {
                let route = e.currentTarget.getAttribute('route')
                return this.$router.push({name: route})
            },
            changeLang(lang) {
                this.$ml.change(lang)
                this.$f7 && this.$f7.panel.close()
            },
        },

        async created() {
            this.routes     = routers.filter(( obj ) => obj.showInDashboard === true)
            let permissions = localStorage.permission ? JSON.parse(localStorage.permission) : []
            this.routes     = this.routes.filter(( obj ) => {
                if (! obj.permission) return true
                return permissions[obj.permission]
            });

            this.rows = Math.ceil(this.routes.length / 2)
            await Query.withMaterials().get()
        },
    };
</script>

<style scoped>
    .f7-icons { font-size: 50px; }
    .title { font-size: 11px;  }
    .card {
        background-image: linear-gradient(#1fc8db, #2cb5e8);
        color: white;
        opacity: 0.95;
    }
</style>